import { gql, TypedDocumentNode } from '@apollo/client'
import {
  UserProfileAttributesFragment,
  USER_PROFILE_ATTRIBUTES_FRAGMENT,
} from 'graphql/fragments/users/userFragments'

export type UpdateSparkUserInput = {
  primaryRole?: number | null
  betaTester?: boolean
  theme?: string
  notificationAttributes?: {
    optedBatching: boolean
    optedOutNotifications: string[]
  }
  outOfOfficeAttributes?: {
    oooFromDate?: string | null
    oooMessage?: string | null
    oooToDate?: string | null
    userOutOfOffice?: boolean
  }
}

type UpdateSparkUserVars = {
  userProfileId: string
  userUpdates: UpdateSparkUserInput
}

type UpdateSparkUserResponse = {
  updateSparkUser: UserProfileAttributesFragment
}

export const UPDATE_SPARK_USER: TypedDocumentNode<
  UpdateSparkUserResponse,
  UpdateSparkUserVars
> = gql`
  ${USER_PROFILE_ATTRIBUTES_FRAGMENT}
  mutation updateSparkUser(
    $userProfileId: ID!
    $userUpdates: UpdateSparkUserInput!
  ) {
    updateSparkUser(userProfileId: $userProfileId, userUpdates: $userUpdates) {
      ...UserProfileAttributes
    }
  }
`

export type UpdateDefaultPartnerAttributesInput = {
  currentVMMRole: number
}

type UpdateDefaultPartnerAttributesVars = {
  userDefaultPartnerAttributes: UpdateDefaultPartnerAttributesInput
}

type UpdateDefaultPartnerAttributesResponse = {
  updateDefaultPartnerAttributes: {
    id: string
  }
}

export const UPDATE_DEFAULT_PARTNER_ATTRIBUTES: TypedDocumentNode<
  UpdateDefaultPartnerAttributesResponse,
  UpdateDefaultPartnerAttributesVars
> = gql`
  mutation updateDefaultPartnerAttributes(
    $userDefaultPartnerAttributes: UpdateUserDefaultPartnerAttributesInput!
  ) {
    updateDefaultPartnerAttributes(
      userDefaultPartnerAttributes: $userDefaultPartnerAttributes
    ) {
      id
    }
  }
`

export type UpdateUserAccreditationInput = {
  accreditations: {
    status: string
    type: string
  }[]
}

export const UPDATE_USER_ACCREDITATION_MUTATION: TypedDocumentNode<
  { updateSparkUser: { id: string } },
  { userProfileId: string; userUpdates: UpdateUserAccreditationInput }
> = gql`
  mutation updateUserAccreditation(
    $userProfileId: ID!
    $userUpdates: UpdateSparkUserInput!
  ) {
    updateSparkUser(userProfileId: $userProfileId, userUpdates: $userUpdates) {
      id
    }
  }
`
